export default {
  // Navigation
  nav: {
    home: 'Home',
    finance: 'Finance',
    exchange: 'RWA',
    wallet: 'Assets',
    notice: 'Notice',
    invite: 'Invite',
    withdrawal: 'Withdraw'
  },

  // Home
  home: {
    title: 'SeekAIpha: Ushering in a New Era of AI-Driven Wealth',
    subtitle: 'Next-generation DeFi protocol that combines artificial intelligence with deflationary economics to create a sustainable crypto asset income engine for you',
    explore: 'Explore Now',
    watchVideo: 'Watch Video',
    
    // Core Issue
    coreIssue: 'The Core Problem We Solve',
    coreIssueDesc: 'Traditional DeFi has fallen into the death spiral of "high returns = high risk". Lacking real value creation, it is an unsustainable Ponzi game.',
    
    // Solution
    solution: 'SeekAIpha\'s Solution',
    solutionDesc: 'Introducing external profits and intrinsic deflation to build a value flywheel.',
    
    // Solution List
    solutionList: {
      ai: {
        title: 'AI-Driven Value Creation',
        tips: '(Let the machine work for you)',
        content: 'Part of the funds are managed by top-tier AI trading strategies. Profits are automatically used to buy back and burn SKP tokens, continuously injecting external market profits into the ecosystem.'
      },
      deflation: {
        title: 'Extremely Deflationary Scarce Assets',
        tips: '(The more circulation, the scarcer)',
        content: 'Through three major mechanisms: AI profit buyback, market cap maintenance fees, and initial deflation, we continuously reduce SKP circulation to build a solid moat for asset value.'
      },
      stability: {
        title: 'Intelligent Market Stability',
        tips: '(Unprecedented anti-drop design)',
        content: 'The original "market cap maintenance wallet" triggers 105% automatic buy-back when the market sells, providing strong support for token prices and achieving soft floor price anchoring.'
      }
    },
    
    // Dual Engine
    dualEngine: 'Dual Engine, Igniting Multiplied Returns',
    
    // Tokens
    tokens: {
      skp: {
        title: 'SKP (Main Equity Token)',
        supply: 'Total Supply: 2.1M (Permanently Deflationary)',
        desc: 'Your Ecosystem Pass: Used for liquidity mining, static returns, community governance, and referral rewards. The hard currency of the entire seekAIpha universe.'
      },
      skb: {
        title: 'SKB (Honor Reward Token)',
        supply: 'Total Supply: 210K (Permanently Deflationary)',
        desc: 'Elite Honor Badge: Only awarded to V3+ community leaders. Scarcer total supply, higher value, a symbol of identity and contribution.'
      }
    },
    
    // Ecosystem
    ecosystem: 'Real-time Ecosystem Pulse',
    ecosystemData: {
      burn: '$SKP Total Burned',
      profit: 'AI Finance Total Profit',
      members: 'Total Community Members',
      locked: 'Total Pool Locked',
      fund: 'Market Cap Fund Balance'
    },
    
    // Income Structure
    incomeStructure: 'Multi-dimensional Income Structure, From Beginner to Leader',
    stages: {
      static: {
        title: 'Static Returns | Stable Foundation',
        items: [
          'V0-V3: 1.5% Daily',
          'V4-V6: 2.1% Daily',
          'V7-V8: 3.0% Daily',
          'Returns from ecosystem growth and AI profits, not pure inflation'
        ]
      },
      referral: {
        title: 'Referral Rewards | Network Power',
        items: [
          'Direct 10% | Indirect 5%',
          'Quickly activate your network effect'
        ]
      },
      leadership: {
        title: 'Community Leadership Award | Global Performance',
        items: [
          'Enjoy district performance dividends, up to 80%',
          'Rewarding true ecosystem builders'
        ]
      },
      honor: {
        title: 'SKB Honor Reward | Peak Glory',
        items: [
          'Exclusive to V3+ members, unlock the second wealth channel.'
        ]
      }
    },
    
    // FAQ
    faq: {
      title: 'Your Questions, Our Clear Answers',
      q1: {
        question: 'Q: Where does my money specifically go?',
        answer: 'A: Every fund is strictly allocated according to smart contracts: 20% for AI finance revenue, 30% injected into DEX pool for protection, 50% into market cap maintenance wallet for price stability.'
      },
      q2: {
        question: 'Q: Is my asset safe if the market crashes?',
        answer: 'A: No investment is risk-free. But our "market cap maintenance wallet" and "105% buy-back mechanism" are specifically designed to counter declines, providing strong buffer and support during market volatility, which traditional DeFi projects lack.'
      },
      q3: {
        question: 'Q: How to start?',
        answer: 'A: Click the "Join Now" button below, connect your wallet, and start your seekAIpha journey from 100 USDT.'
      }
    },
    
    // Footer
    footer: {
      cta: 'Ready to Become an Early Co-builder of Next-Gen DeFi',
      ctaDesc: 'Join tens of thousands of pioneers to harness the future of AI',
      downloadWhitepaper: 'Download Whitepaper',
      joinTelegram: 'Join Official Telegram'
    }
  },

  // Wallet
  wallet: {
    title: 'My Wallet',
    totalAssets: 'Estimated Total Assets',
    exchange: 'Exchange',
    withdrawal: 'Withdraw',
    myLevel: 'My Level',
    personalPerformance: 'Personal Performance',
    teamPerformance: 'Team Performance',
    districtPerformance: 'District Performance',
    areaPerformance: 'Area Performance',
    maxIncome: 'Max Income',
    teamNum: 'Team Members',
    remainingIncome: 'Remaining Income',
    directNum: 'Direct Referrals',
    myAssets: 'My Assets',
    assetRecord: 'Asset Records',
    accumulatedIncome: 'Accumulated Income',
    amount: 'Amount:',
    source: 'Source:',
    time: 'Time:',
    noRecord: 'No Records'
  },

  // Invite
  invite: {
    title: 'SeekAIpha: Ushering in a New Era of AI-Driven Wealth',
    subtitle: 'Next-generation DeFi protocol that combines artificial intelligence with deflationary economics to create a sustainable crypto asset income engine for you',
    myInviteCode: 'My Invitation Code',
    inviteRecord: 'Invitation Records',
    registerTime: 'Register Time:',
    performance: 'Performance',
    noRecord: 'No Records',
    myLevel: 'My Level'
  },

  // Notice
  notice: {
    title: 'Platform Notice',
    noMore: 'No more',
    back: 'Back',
    viewCount: 'views'
  },

  // Exchange
  exchange: {
    title: 'Swap Exchange',
    balance: 'Balance:',
    max: 'MAX',
    swapNow: 'Swap Now',
    enterAmount: 'Please enter correct amount',
    selectCoin: 'Please select coin',
    swapFailed: 'Swap failed',
    record: 'Exchange Records',
    amount: 'Amount:',
    time: 'Time:',
    noMore: 'No more',
    popup: {
      title: 'Exchange',
      subtitle: 'Deposit to Mine SKP',
      depositAmount: 'Deposit Amount',
      pay: 'Pay Now'
    }
  },

  // Finance/Deposit
  recharge: {
    participate: 'Participate Deposit',
    repurchase: 'Repurchase',
    record: 'Deposit Records',
    selectAmount: 'Select Amount',
    depositNow: 'Deposit Now',
    payNow: 'Pay Now',
    balance: 'Balance:',
    insufficientBalance: 'Insufficient Balance',
    enterAmount: 'Please enter repurchase amount',
    minAmount: 'Repurchase amount cannot be less than',
    paySuccess: 'Payment successful, waiting for block confirmation',
    historyRecord: 'History Records',
    status: 'Status:',
    pending: 'Pending',
    completed: 'Completed',
    failed: 'Failed',
    currentIncome: 'Current Income',
    accumulatedIncome: 'Accumulated Income',
    toBeReleased: 'To Be Released',
    released: 'Released'
  },

  // Common
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    submit: 'Submit',
    success: 'Success',
    failed: 'Failed',
    loading: 'Loading...',
    noData: 'No Data',
    copySuccess: 'Copied',
    copyFailed: 'Copy Failed',
    connectWallet: 'Connect Wallet',
    disconnect: 'Disconnect',
    invitationCode: 'Invitation Code',
    enterInvitationCode: 'Please enter invitation code'
  },

  // Withdrawal
  withdrawal: {
    title: 'Withdraw',
    withdrawNow: 'Withdraw Now',
    withdrawAmount: 'Withdraw Amount',
    fee: 'Fee:',
    record: 'Withdrawal Records',
    balance: 'Balance:',
    max: 'MAX',
    withdrawSuccess: 'Withdrawal successful',
    notEnabled: 'Withdrawal not enabled for this coin',
    minAmount: 'Withdrawal amount cannot be less than',
    maxAmount: 'Withdrawal amount cannot be greater than',
    exceedBalance: 'Withdrawal amount cannot exceed balance',
    noMore: 'No more'
  },

  // HTTP
  http: {
    request: 'Request error',
    repetition: 'Repeated request',
    timeout: 'Timeout',
    err: 'Failed to connect to the server.'
  }
}
